import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Hero from "../components/Hero";
import MarqueeRibbon from "../components/MarqueeRibbon";
import Posicionamento from "../components/Posicionamento";
import Experiencias from "../components/Experiencias";
import Diferenciais from "../components/Diferenciais";
import SobreMagnus from "../components/SobreMagnus";
import Transporte from "../components/Transporte";
import Depoimentos from "../components/Depoimentos";
import Galeria from "../components/Galeria";
import InstagramSection from "../components/InstagramSection";
import Faq from "../components/Faq";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import FloatingUI from "../components/FloatingUI";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        window.__lenis?.scrollTo(location.hash, { offset: -130, immediate: true }) ||
          document.querySelector(location.hash)?.scrollIntoView();
      }, 400);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <MarqueeRibbon />
        <Posicionamento />
        <Experiencias />
        <Diferenciais />
        <SobreMagnus />
        <Transporte />
        <Depoimentos />
        <Galeria />
        <InstagramSection />
        <Faq />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingUI />
    </>
  );
}
